const YOUTUBE_HOSTS = ['youtube.com', 'www.youtube.com', 'm.youtube.com', 'youtu.be'];

const PLACEHOLDER_IMAGE_PATTERNS = [
  /source\.unsplash\.com/i,
  /images\.unsplash\.com\/photo-1516321318423-f06f85e504b3/i,
];

const getYouTubeVideoId = (url) => {
  if (!url || typeof url !== 'string') return '';

  try {
    const parsed = new URL(url);

    if (parsed.hostname.includes('youtu.be')) {
      return parsed.pathname.replace('/', '').trim();
    }

    if (YOUTUBE_HOSTS.some((host) => parsed.hostname.includes(host)) && parsed.searchParams.get('v')) {
      return parsed.searchParams.get('v').trim();
    }

    const shortsMatch = parsed.pathname.match(/\/shorts\/([^/?]+)/i);
    if (shortsMatch?.[1]) {
      return shortsMatch[1].trim();
    }
  } catch {
    const directMatch = url.match(/(?:v=|youtu\.be\/|\/shorts\/)([A-Za-z0-9_-]{6,})/i);
    return directMatch?.[1] || '';
  }

  return '';
};

export const getCourseVideoUrl = (course) => {
  const fullJson = course?.full_json || {};
  const modules = course?.modules || fullJson.modules || [];

  for (const module of modules) {
    const lessons = module?.lessons || [];
    for (const lesson of lessons) {
      if (lesson?.videoUrl) return lesson.videoUrl;
    }
  }

  return course?.videoUrl || fullJson.videoUrl || '';
};

export const getCourseThumbnail = (course) => {
  const explicitImage = course?.image || course?.thumbnail || course?.image_url;
  const isPlaceholderImage = explicitImage
    && PLACEHOLDER_IMAGE_PATTERNS.some((pattern) => pattern.test(explicitImage));

  if (explicitImage && !isPlaceholderImage) return explicitImage;

  const videoUrl = getCourseVideoUrl(course);
  const videoId = getYouTubeVideoId(videoUrl);

  if (videoId) {
    return `https://img.youtube.com/vi/${videoId}/hqdefault.jpg`;
  }

  return '';
};
